export default __webpack_public_path__ + "static/media/Image (14).675d6caf.png";